import { render, staticRenderFns } from "./YesNoTextareaField.vue?vue&type=template&id=395b0dc6&scoped=true"
import script from "./YesNoTextareaField.vue?vue&type=script&lang=ts"
export * from "./YesNoTextareaField.vue?vue&type=script&lang=ts"
import style0 from "./YesNoTextareaField.vue?vue&type=style&index=0&id=395b0dc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395b0dc6",
  null
  
)

export default component.exports